import type { ReactNode } from 'react'

import { CircleDashedIcon, GiftIcon } from '@phosphor-icons/react'
import { ConsumptionIcon } from '@assets/svgs/ConsumptionIcon'
import { DepreciationIcon } from '@assets/svgs/DepreciationIcon'
import { InvoicingIcon } from '@assets/svgs/InvoicingIcon'
import { OtherExpensesIcon } from '@assets/svgs/OtherExpensesIcon'
import { PeopleIcon } from '@assets/svgs/PeopleIcon'
import { emotionTheme } from '@styles/theme'
import { findAccountConfig } from '@pages/ConsolidatedEntry/constants/accountsConfig'

import type { AccountIconKey } from '@pages/ConsolidatedEntry/constants/accountsConfig'

// Cor padrão de cada Conta (definida pelo produto) — usada em todas as tabelas/cards de contas
const ACCOUNT_ICON_MAP: Record<AccountIconKey, { icon: ReactNode; color: string }> = {
  invoicing: { icon: <InvoicingIcon />, color: '#3A9397' },
  consumption: { icon: <ConsumptionIcon />, color: '#F2793A' },
  people: { icon: <PeopleIcon />, color: '#D96060' },
  otherExpenses: { icon: <OtherExpensesIcon />, color: '#9C3F58' },
  depreciation: { icon: <DepreciationIcon />, color: '#BF9C6A' },
  bonus: { icon: <GiftIcon size={15} />, color: '#51B77D' }
}

const FALLBACK_ICON = { icon: <CircleDashedIcon size={15} />, color: emotionTheme.colors.gray[400] }

export const getAccountIcon = (accountName: string) => {
  const config = findAccountConfig(accountName)

  return config ? ACCOUNT_ICON_MAP[config.key] : FALLBACK_ICON
}
